import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

export const FreeUpgradeUnavailableMessages = ({
  message = {
    maxValueReached: false,
    bookingAlreadyUpgradedForFree: false,
    freeUpgradeUnavailable: {},
    maxAmountPerJourney: false,
    maxAmountPerPassenger: false
  }
}) => {
  if (message.maxValueReached) {
    return <FormattedMessage id="aftersales.freeUpgrade.budgetReached" />;
  }

  if (message.bookingAlreadyUpgradedForFree) {
    return <FormattedMessage id="aftersales.freeUpgrade.bookingAlreadyUpgradedForFree" />;
  }

  if (message.maxAmountPerJourney) {
    return <FormattedMessage id="aftersales.freeUpgrade.maxAmountPerJourney" />;
  }

  if (message.maxAmountPerPassenger) {
    return <FormattedMessage id="aftersales.freeUpgrade.maxAmountPerPassenger" />;
  }

  return (
    <FormattedMessage
      id="aftersales.freeUpgrade.unavalaibleTrain"
      values={{
        direction: message.freeUpgradeUnavailable?.direction,
        carrier: message.freeUpgradeUnavailable?.carrier,
        trainNumber: message.freeUpgradeUnavailable?.trainNumber,
        date: message.freeUpgradeUnavailable?.date
      }}
    />
  );
};

FreeUpgradeUnavailableMessages.propTypes = {
  message: PropTypes.shape({
    maxValueReached: PropTypes.bool,
    bookingAlreadyUpgradedForFree: PropTypes.bool,
    freeUpgradeUnavailable: PropTypes.shape({
      direction: PropTypes.string,
      carrier: PropTypes.string,
      trainNumber: PropTypes.string,
      date: PropTypes.string
    }),
    maxAmountPerJourney: PropTypes.bool,
    maxAmountPerPassenger: PropTypes.bool
  })
};
